














































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { getListByUnit2, getPointList } from '@/api/videoDevice/index'
import { openVideo } from '@/configs/functions'

@Component({
  components: {}
})
export default class VideosView extends Vue {
  public name = 'VideosView'
  public loading = false
  public list: any[] = []
  public $refs!: {
  }
  //数据加载
  public loadData(unitId: number) {
    if (unitId == 0) {
      this.$message({
        message: '文保单位未匹配，请检查',
        type: 'warning'
      })
      console.log('UnitId为0，请赋值')
    }
    else {
      //触发控件的查询事件
      this.fetchData(unitId)
    }
  }
  public fetchData(unitId: number) {
    this.loading = true
    getListByUnit2(unitId).then((response: { data: any }) => {
      this.list = response.data
      this.loading = false
    }).catch((error: any) => {
      console.log(error)
    })
  }
  public expandKeys: number[] = []
  public expandClass(id: number): string {
    if (this.expandKeys.findIndex(v => v == id) > -1) {
      return 'el-icon-arrow-down'
    }
    else {
      return 'el-icon-arrow-right'
    }
  }

  public rowExpand(row: any, event: any, column: any) {
    var keyId = row.Id
    var index = this.expandKeys.findIndex(v => v == keyId)
    if (index < 0) {
      if (!row.childs || row.childs.length == 0) {
        row.childs = []
        row.loading = false
        this.fetchChilds(row)
      }
      //展开，查询子级
      this.expandKeys.push(keyId)
    } else {
      // 移除展开项      
      this.expandKeys.splice(index, 1)
    }
  }
  public fetchChilds(row: any) {
    row.loading = true
    getPointList(row.Id).then((response: { data: any }) => {
      const data = response.data
      if (data) {
        row.childs = data
        row.loading = false

        //对应的视频设备索引
        let videoIndex = this.list.findIndex((v: any) => v.Id == row.Id)
        this.$set(this.list, videoIndex, row)
      }
      row.loading = false
    })
  }
  public playVideo(parentIndex: number, index: number) {
    var parent = this.list[parentIndex]
    if (parent) {
      var data = parent.childs[index]
      var info = {
        title: data.PointName,
        code: data.PointNumber,
        playBack: false,
        storageType: data.StorageType
      }
      if (window.baseConfig.UseH5Player) {
        window.eventBus.$emit('openH5Player', info)
      }
      else {
        openVideo(info)
        // window.eventBus.$emit('openVideoPlay', info)
      }
    }
  }
}
